<template>
    <div class="videoImage">
        <iframe width="100%" height="500"
                    :src="data">
</iframe>
      
          <!-- <video width="100%" height="100%" controls poster="/cb/5.jpg">
            <source src="https://www.youtube.com/watch?v=YC3ZDWRF7B4" type="video/mp4" />
          </video> -->
        </div>
</template>
<script>
export default {
    props:['data']
}
</script>